import { documentLoaded, insertScript, waitFor } from './trackingHelper'
import cookieConfig from './cookieConfig.json'

let accepted: string[] = []
let cookieFirstLoaded: Promise<void> | undefined = undefined
type CookieFirstCallback = (services: typeof accepted) => void
let callbacks: CookieFirstCallback[] = []

const updateAccepted = (consent: Record<string, boolean>) => {
  const localAccepted = Object.entries(consent)
    .filter(([, v]) => !!v)
    .map(([k]) => k)

  accepted = localAccepted

  for (const cb of callbacks) {
    try {
      cb(localAccepted)
    } catch (e) {
      console.error(e)
    }
  }
}

const cookieFirstListener = () => {
  if (cookieFirstLoaded) {
    return cookieFirstLoaded
  }

  cookieFirstLoaded = new Promise<void>((res) => {
    let resolved = false
    const resolve = (e: any) => {
      updateAccepted(e.detail || {})

      if (resolved) {
        return
      }
      resolved = true

      res()
    }

    window.addEventListener('cf_services_consent', resolve)
    window.addEventListener('cf_services_consent_loaded', resolve)
  })

  return cookieFirstLoaded
}

const getAcceptedServices = async () => {
  await cookieFirstListener()

  return accepted
}

export const onCookieFirstServiceUpdate = (cb: CookieFirstCallback) => {
  getAcceptedServices().then(cb)

  callbacks.push(cb)
}

export const beforeBanner = async () => {
  const cookieName = 'cookiefirst-consent'
  const matcher = new RegExp(`\\s*${cookieName}=`)
  const cookie = document.cookie
    .split(';')
    .find((s) => matcher.test(s))
    ?.trim()
  if (!cookie || cookie.length < cookieName.length + 2) {
    return
  }

  try {
    const value = JSON.parse(
      decodeURIComponent(cookie.substring(cookieName.length + 1))
    )

    const report: Record<string, boolean> = {}
    for (const key in cookieConfig) {
      if (!value.hasOwnProperty(key)) {
        continue
      }

      const active = !!value[key]

      for (const service of cookieConfig[key as keyof typeof cookieConfig]) {
        report[service] = (report[service] ?? true) && active
      }
    }

    updateAccepted(report)
  } catch (e) {}
}

export const bootstrapCookieFirst = async () => {
  const src = process.env.GATSBY_COOKIE_FIRST_SRC
  if (!src) {
    return
  }

  const cookiePattern = new RegExp('(^|;\\s*)cookiefirst-consent=')
  if (!cookiePattern.test(document.cookie)) {
    await documentLoaded('complete')
    await waitFor(2500)
  } else {
    await beforeBanner()
  }

  await insertScript(src, 'ee-cookiefirst-script')
}
